import { CHECKED, UNCHECKED, INDETERMINATE, DISABLED } from './constants';

export default function getSelectableCheckboxState({
  selectedCount,
  totalCount,
  blockedCount
}) {
  const selectableCount = totalCount - blockedCount;

  if (totalCount > 0 && selectableCount === 0) return DISABLED;
  if (selectedCount === 0 || selectableCount === 0) return UNCHECKED;
  if (selectedCount >= selectableCount) return CHECKED;

  return INDETERMINATE;
}



// WEBPACK FOOTER //
// ./components/checkbox/get-selectable-checkbox-state.js